import React from 'react';
import { TypedMemo } from '../../common/types';
import type { DirectedWizardStep } from '../directedSteps';
import { madeSectionId } from './howMadeSections';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for "How it was made"; each part uses its own slice of it */
import styles from './HowMade.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface HowMadeSectionProps {
  step: DirectedWizardStep;
  eyebrow: string;
  title: string;
  text?: string;
  /** The round switch of the step, on the right of the head. */
  aside?: React.ReactNode;
  children: React.ReactNode;
}

/** One step of "How it was made" (design l1 `.hws`): the eyebrow, the title, the line, the body. */
const HowMadeSectionComponent: React.FC<HowMadeSectionProps> = ({ step, eyebrow, title, text, aside, children }) => (
  <section className={styles.section} id={madeSectionId(step)} data-testid={madeSectionId(step)}>
    <div className={styles.sectionHead}>
      <div className={styles.sectionTitles}>
        <span className={styles.eyebrow}>{eyebrow}</span>
        <h3>{title}</h3>
        {text !== undefined && <p className={styles.sectionText}>{text}</p>}
      </div>
      {aside}
    </div>
    {children}
  </section>
);

export const HowMadeSection = TypedMemo(HowMadeSectionComponent);
